export class ExperimentParameterRanges {
  /* ---------------------------- General ---------------------------- */

  static readonly SAMPLE_TIME_MINS = { min: 3, max: 1000, step: 1, default: 5 };
  static readonly EXPERIMENT_DURATION_HOURS = {
    min: 1,
    max: 1000,
    step: 1,
    default: 96,
  };
  // Note that rpm can also be 0 but this is handled separately. Cannot be between 1 and 499.
  static readonly SPEED_RPM = { min: 500, max: 5800, step: 20, default: 4000 };
  static readonly AMBIENT_TEMPERATURE = {
    min: 0,
    max: 50,
    step: 0.5,
    default: 20,
    minAmbientTempWarning: 15,
    maxAmbientTempWarning: 40,
    warningMessage:
      'Warning: Ambient temperature is outside the recommended range.',
  };
  static readonly CULTURE_TEMPERATURE = {
    min: 0, // Will be set dynamically based on ambient temperature
    max: 50,
    step: 0.1,
    default: 37,
  };

  static readonly DESCRIPTION = {
    minLength: 2,
    maxLength: 500,
  };

  /* ---------------------------- Fluoro ---------------------------- */

  static readonly LED_INTENSITY = { min: 0, max: 255, step: 1, default: 255 };
  static readonly INTEGRATION_TIME = {
    min: 25,
    max: 5000,
    step: 10,
    default: 100,
  };

  /* ---------------------------- Oxygen ---------------------------- */

  static readonly SALINITY = { min: 0, max: 350, step: 1, default: 0 };

  /* ---------------------------- Turbidostat ---------------------------- */

  static readonly TARGET_OD = { min: 0.1, max: 10.0, step: 0.05, default: 0.3 };

  /* ---------------------------- Chemostat ---------------------------- */

  static readonly FLOW_RATE = { min: 0, max: 100, step: 0.1, default: 2 };

  /* ---------------------------- pH Control ---------------------------- */

  static readonly TARGET_PH = { min: 0, max: 14, step: 0.05, default: 7.0 };
  static readonly PUMP_DURATION_SECONDS = {
    min: 0.3,
    max: 15,
    step: 0.1,
    default: 0.3,
  };
  static readonly PUMP_TUBE_LENGTH_CM = {
    min: 10,
    max: 300,
    step: 1,
    default: 85,
  };

  /* ---------------------------- Morbidostat ---------------------------- */

  static readonly OD_THRESHOLD = { min: 0.1, max: 5, step: 0.05, default: 0.3 };
  static readonly DILUTION_PERIOD_MINS = {
    min: 5,
    max: 200,
    step: 1,
    default: 30,
  };
  static readonly DILUTION_FACTOR = {
    min: 0.01,
    max: 0.25,
    step: 0.01,
    default: 0.2,
  };

  /* ---------------------------- Sparging ---------------------------- */

  static readonly SPARGING_AIRFLOW = {
    min: 0,
    max: 700,
    step: 1,
    default: 100,
    warning: 500,
    warningMessage: 'Warning: Airflow rate is outside of recommended range',
  };
}
